import '../../styles/sections/related-products.scss';

class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.performed = this.hasAttribute('performed');
    this.recommendationsUrl = this.getAttribute('url');

    if (!this.performed) this.fetchRecommendations();
  }

  async fetchRecommendations() {
    const recommendtaionsResponse = await fetch(this.recommendationsUrl);
    const recommendationsHtml = await recommendtaionsResponse.text();

    const parsedRecommendations = new DOMParser().parseFromString(recommendationsHtml, 'text/html');
    const recommendations = parsedRecommendations.querySelector('related-products');

    this.innerHTML = recommendations.innerHTML;
  }
}

customElements.define('related-products', RelatedProducts);
